module.exports = __webpack_public_path__ + "img/pic_07@2x.54e6ed7b.png";